import { createSelector } from "reselect";
import { userIsAuthorized } from "@/components/currentUser/CurrentUser.state";
import { userIsAuthenticated } from "@/util/session";

export const userIsLoggedIn = createSelector(
  userIsAuthenticated,
  userIsAuthorized,
  (isAuthenticated, isAuthorized) => isAuthorized && isAuthenticated
);
